// extracted by mini-css-extract-plugin
export default {"btop":"_91e3cda93e _7b9ec5a54b _3c8eb2e4b8","icon":"e0237ac8dc a70add968e","btoppink":"_05291a9549 bc7f0cb4b5"};